export default __webpack_public_path__ + "static/media/huaweiZ3.124b02ed.jpg";